import { Button, Form, Select } from 'antd';
import { useForm } from 'antd/es/form/Form';
import dayjs from 'dayjs';
import React, { FC } from 'react';

import { dateFormat } from '../../../common/constants';
import { openNotification } from '../../../common/helpers';
import { NotificationTypes } from '../../../common/interfaces';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { userApi } from '../../../store/api/user.api';
import { LegalStatus, WorksheetData } from '../Registration.interfaces';
import IndividualEntrepreneurFields from './IndividualEntrepreneurFields';
import IndividualFields from './IndividualFields';
import LegalFields from './LegalFields';
import { getInitialValues } from './Worksheet.helpers';
import styles from './Worksheet.module.scss';

type Props = {
  name?: string;
  nextStep: () => void;
  prevStep: () => void;
};

export const Worksheet: FC<Props> = ({ nextStep, prevStep }) => {
  const [form] = useForm();

  const [updateUserInfo, { isLoading: loadingUpdate }] =
    userApi.useUpdateUserInfoMutation();

  const { countries, userInfo } = useTypedSelector(
    (state) => state.registration,
  );

  const initFormData = userInfo ? getInitialValues(userInfo) : {};

  const handleSubmit = async (values: WorksheetData) => {
    let copyValues = { ...values };

    if ('regDate' in copyValues) {
      copyValues = {
        ...values,
        regDate: dayjs(values.regDate).format(dateFormat) as string,
      };
    }

    try {
      await updateUserInfo(copyValues).unwrap();
      openNotification(
        NotificationTypes.SUCCESS,
        `Данные пользователя успешно обновлены`,
      );
      nextStep();
    } catch (e) {
      openNotification(
        NotificationTypes.ERROR,
        `Произошла ошибка при попытке обновить данные анкеты: ${e}`,
      );
    }
  };

  return (
    <div>
      <h3 className={styles.title}>Анкета компании</h3>

      <Form
        initialValues={initFormData}
        name="form"
        onFinish={handleSubmit}
        form={form}
        className={styles.form}
        layout="vertical"
      >
        <Form.Item
          name="countryId"
          rules={[{ required: true, message: 'Обязательное поле' }]}
          className={styles['form-item']}
          label="Страна регистрации"
        >
          <Select disabled options={countries} />
        </Form.Item>

        {userInfo?.legalStatus === LegalStatus.LEGAL && (
          <LegalFields form={form} />
        )}

        {userInfo?.legalStatus === LegalStatus.INDIVIDUAL && (
          <IndividualFields form={form} />
        )}

        {userInfo?.legalStatus === LegalStatus.INDIVIDUAL_ENTREPRENEUR && (
          <IndividualEntrepreneurFields form={form} />
        )}

        <div className={styles['steps-buttons']}>
          <Button
            style={{ width: '102px' }}
            htmlType="button"
            onClick={prevStep}
            type="default"
            size="large"
          >
            Назад
          </Button>

          <Button
            loading={loadingUpdate}
            style={{ width: '102px' }}
            htmlType="submit"
            type="primary"
            size="large"
          >
            Далее
          </Button>
        </div>
      </Form>
    </div>
  );
};
